<header>
    <mat-toolbar class="border-b-8 border-primary-700">
        <mat-toolbar-row>
            <div class="desktop-header mx-5">
                <a href="https://www.enterprisewireless.org/">
                    <img
                        class="pr-5 lg:max-w-[170px] xl:max-w-[210px]"
                        src="assets/images/EWA_Logo.jpg"
                        alt="EWA Logo"
                    />
                </a>

                @for (headerLink of headerLinks; track headerLink) {
                    <a
                        title="menu"
                        mat-button
                        class="header-buttons whitespace-normal text-center"
                        [matMenuTriggerFor]="menu"
                        (mouseenter)="mouseEnter(menuTrigger)"
                        (mouseleave)="mouseLeave(menuTrigger)"
                        #menuTrigger="matMenuTrigger"
                        href="{{ headerLink.url }}"
                        [innerHtml]="headerLink.text"
                    >
                    </a>

                    <mat-menu
                        #menu="matMenu"
                        [hasBackdrop]="false"
                        class="desktop-menu"
                    >
                        <div
                            (mouseenter)="mouseEnter(menuTrigger)"
                            (mouseleave)="mouseLeave(menuTrigger)"
                        >
                            @for (
                                childLink of headerLink.childLinks;
                                track childLink
                            ) {
                                <a mat-menu-item href="{{ childLink.url }}">{{
                                    childLink.text
                                }}</a>
                            }
                        </div>
                    </mat-menu>
                }

                <div class="my-auto relative max-w-[140px]">
                    <input
                        matInput
                        class="w-full pr-10 text-sm search-input"
                        placeholder="Search"
                    />
                    <mat-icon
                        class="absolute right-0 top-0 mt-2 mr-2 cursor-pointer"
                        >search</mat-icon
                    >
                </div>
                <app-header-dropdown [isMobile]="false"></app-header-dropdown>
            </div>
            <app-header-mobile class="w-full lg:hidden"></app-header-mobile>
        </mat-toolbar-row>
    </mat-toolbar>
</header>
